<template>
  <div id="checkbox-form" class="pb-3" v-if="question && question.is_enabled">
    <b-form-group v-if="content && content.visible">
      <template slot="label">
        <div class="question-title mb-2">
          {{ question.question }}
          <sup class="text-danger font-weight-bold" v-if="content.required">
            *
          </sup>
        </div>
        <div>
            <ImageRender
              v-if="question.image"
              :imgBase64="question.image" :showCloseButton="false"/>
        </div>
      </template>
      <b-container>
        <b-row>
          <b-form-checkbox
            v-for="(option, key) in content.attributes.options"
            v-model="selected"
            :key="key"
            :value="option.answer"
            class="mb-2 text-break"
            :class="content.attributes.width === 'full' ? 'col-12' : 'col-6'"
          >
            {{ option.answer }}
          </b-form-checkbox>
          <b-form-invalid-feedback :state="isInvalid(question.question)">
            {{ errorMessage(question.question) }}
          </b-form-invalid-feedback>
        </b-row>
      </b-container>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImageRender from "../../../components/ImageRender.vue";
export default {
  name: "Checkbox",
  components: {
    ImageRender,
  },
  props: ["question", "answers"],
  data() {
    return {
      content: null,
      selected: [],
    };
  },
  methods: {
    isInvalid(field) {
      if (this.errors === null) {
        return null;
      } else {
        return !Object.keys(this.errors).includes(field)
          ? null
          : !Object.keys(this.errors).includes(field);
      }
    },
    errorMessage(field) {
      if (this.errors === null) {
        return "";
      } else if (Object.keys(this.errors).includes(field)) {
        return Array.isArray(this.errors[field])
          ? this.errors[field].join(" ")
          : this.errors[field];
      }
    },
  },
  watch: {
    selected(value) {
      this.answers[
        this.question.question
      ] = this.content.attributes.options
        .filter((option) => value.includes(option.answer))
        .map(({ answer }) => answer).join(", ");
    },
    question() {
      if (this.question.contents.length) {
        this.content = this.question.contents[0];
      }

      if (this.answers[this.question.question] !== undefined)
        this.selected = this.answers[this.question.question];
      else this.answers[this.question.question] = "";
    }
  },
  computed: {
    ...mapGetters("survey", ["errors"]),
  },
  created() {
    if (this.question.contents.length) this.content = this.question.contents[0];

    if (this.answers[this.question.question] !== undefined)
      this.selected = this.answers[this.question.question].split(", ");
    else this.answers[this.question.question] = "";
  },
};
</script>

<style>
</style>